import { put, select, takeLatest } from 'redux-saga/effects'
import { PCRConstants } from '../store/pcr.constants'
import Logger from '../../../services/logger.service'
import { getPcrIdSelector } from '../../home/selectors'
import { getUserSelector } from '../../user/selectors'
import { handleApiError } from '../../../components/apiErrorHandler/store/apiErrorHandler.actions'
import { ZollApiErrorResponse } from '../../zollApi/store/zollApi.types'
import PcrLoggerService from '../../pcr/services/pcrLogger.service'
import { IUserState } from '../../user/store/user.types'
import { getPcrErrorSelector } from '../selectors/pcrError.selector'

export function* processCRUDPcrException() {
  try {
    const pcrId: string = yield select(getPcrIdSelector)
    const user: IUserState = yield select(getUserSelector)
    const error: string = yield select(getPcrErrorSelector)
    const { serviceId, userId } = user
    PcrLoggerService.crudError(pcrId, userId, serviceId, error)

    const logoutError: ZollApiErrorResponse = {
      messages: [
        {
          status: 0,
          level: {
            name: 'Severe',
          },
          display: [
            {
              name: 'Alert',
            },
          ],
          format: '',
          message: 'You must re-enter your user credentials to continue documentation.',
        },
      ],
      status: 0,
      callback: 'logout',
    }
    yield put(handleApiError(logoutError))
  } catch (e) {
    Logger.error(`Error processing pcr exception ${e}`)
  }
}

export function* processCRUDPcrExceptionSaga() {
  yield takeLatest([PCRConstants.CRUD_PCR_EXCEPTION], processCRUDPcrException)
}
